const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    description: '支持1080P高清画质，智能适配网速，告别卡顿缓冲，带来影院级追剧体验',
  },
  {
    id: 2,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    description: '热门剧集第一时间更新上线，追剧快人一步，不错过任何精彩剧情',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量剧集资源',
    description: '收录两万余部电视剧，从热播新剧到经典老剧，类型齐全满足各种口味',
  },
  {
    id: 4,
    icon: 'ri-vip-crown-line',
    title: '完全免费观看',
    description: '无需注册登录，无需会员付费，打开网页即可畅享所有电视剧全集',
  },
];

const mediaItems = [
  {
    id: 1,
    title: '本月新剧抢先看',
    description: '七月热门新剧预告合集，精彩剧情一睹为快',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20preview%20collage%20style%20with%20dramatic%20scene%20montage%2C%20film%20strip%20frame%20borders%2C%20warm%20golden%20spotlight%20effect%2C%20theater%20screen%20with%20curtains%2C%20elegant%20cinema%20aesthetic%2C%20rich%20contrast%20and%20dramatic%20lighting%2C%20professional%20film%20production%20atmosphere&width=800&height=450&seq=media-01-preview&orientation=landscape',
    duration: '新剧预告',
  },
  {
    id: 2,
    title: '经典老剧重温',
    description: '带你回顾那些年我们一起追过的神级电视剧',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20television%20set%20in%20a%20cozy%20living%20room%20with%20warm%20evening%20light%2C%20old%20TV%20showing%20classic%20Chinese%20drama%20scene%2C%20retro%20interior%20design%20elements%2C%20soft%20sepia%20and%20warm%20amber%20tones%2C%20sentimental%20and%20comforting%20atmosphere&width=800&height=450&seq=media-02-classic&orientation=landscape',
    duration: '经典回顾',
  },
  {
    id: 3,
    title: '独家幕后花絮',
    description: '热门剧集拍摄幕后，演员访谈与片场精彩瞬间',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20set%20with%20professional%20camera%20equipment%20and%20warm%20studio%20lights%2C%20director%20chair%20and%20clapperboard%2C%20creative%20atmosphere%20with%20soft%20natural%20window%20light%2C%20cinematic%20production%20aesthetic%2C%20warm%20and%20inviting%20workspace%20vibe&width=800&height=450&seq=media-03-bts&orientation=landscape',
    duration: '幕后花絮',
  },
];

export default function FeatureMediaSection() {
  return (
    <>
      <section id="features" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              追剧优势
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              四大核心优势，为你打造最舒适的追剧体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
              >
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-primary-600 text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="media" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              精彩看点
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              汇集精彩预告与幕后内容，发现更多追剧乐趣
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group block bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-300/50"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).parentElement!.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                      <i className="ri-play-fill text-primary-600 text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded text-[10px] font-medium bg-black/60 text-white">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-600">{item.description}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}